// @ts-nocheck
/**
 * FeedFlyout: activity pulse panel.
 * Status-based color bars (not category):
 *   purple = Vela draft, red = urgent/overdue, yellow = pending,
 *   green = done/paid, gray = normal FYI
 * Backend wiring: replace useFeedEvents with real hook later.
 */
import React, { useState } from 'react';
import { FlyoutPanel } from './Flyouts';

const FILTERS = [
  { id: 'all',      label: 'All' },
  { id: 'vela',     label: 'Vela drafts' },
  { id: 'payments', label: 'Payments' },
  { id: 'payroll',  label: 'Payroll' },
  { id: 'invoices', label: 'Invoices' },
  { id: 'bills',    label: 'Bills' },
  { id: 'team',     label: 'Team' },
];

const STATUS_BAR = {
  vela:    '#8B5CF6',
  urgent:  '#DC2626',
  pending: '#CA8A04',
  done:    '#0F6E56',
  normal:  '#CBD5E1',
};

// Placeholder; replace with real backend hook later
function useFeedEvents(filterId) {
  return [];
}

export function FeedFlyout({ onClose, onNavigate, flyoutId, onPanelEnter, onPanelLeave, anchorTop }) {
  const [activeFilter, setActiveFilter] = useState('all');
  const events = useFeedEvents(activeFilter);

  const title = (
    <div>
      <div style={{ fontSize:15, fontWeight:800, color:'#0E1A1A' }}>Activity feed</div>
      <div style={{ fontSize:11, color:'#64748B', fontWeight:500, marginTop:2 }}>Everything happening across your business</div>
    </div>
  );

  return (
    <FlyoutPanel
      title={title}
      onClose={onClose}
      width={420}
      flyoutId={flyoutId}
      onPanelEnter={onPanelEnter}
      onPanelLeave={onPanelLeave}
      anchorTop={anchorTop}
      capHeight={480}
    >
      <div style={{ display:'flex', gap:6, padding:'10px 16px', borderBottom:'1px solid #F1F5F9', overflowX:'auto', scrollbarWidth:'none' }}>
        {FILTERS.map(function(f) {
          const isActive = activeFilter === f.id;
          return (
            <div
              key={f.id}
              onClick={function() { setActiveFilter(f.id); }}
              style={{
                background: isActive ? '#0E1A1A' : '#F1F5F9',
                color:      isActive ? '#fff'    : '#64748B',
                fontSize: 11, fontWeight: 600,
                padding: '5px 12px', borderRadius: 999,
                cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0,
                transition: 'all 0.15s'
              }}
            >
              {f.label}
            </div>
          );
        })}
      </div>

      {events.length === 0 ? (
        <div style={{ padding:'48px 24px', textAlign:'center', color:'#64748B', fontSize:13, lineHeight:1.7 }}>
          No activity to show yet.<br/>
          Events will appear here as they happen.
        </div>
      ) : (
        <div>
          {events.map(function(ev) {
            return (
              <div key={ev.id} style={{ padding:'11px 16px', display:'flex', alignItems:'flex-start', gap:10, borderBottom:'1px solid #F8FAFC', cursor:'pointer' }}>
                <div style={{ width:3, alignSelf:'stretch', borderRadius:2, flexShrink:0, background: STATUS_BAR[ev.status] || '#CBD5E1' }}/>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:600, color:'#0E1A1A', marginBottom:2 }}>{ev.title}</div>
                  <div style={{ fontSize:11, color:'#64748B' }}>{ev.meta}</div>
                </div>
                <div style={{ fontSize:10, color:'#64748B', whiteSpace:'nowrap' }}>{ev.time}</div>
              </div>
            );
          })}
        </div>
      )}
    </FlyoutPanel>
  );
}
